<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
            <li><a href="#">首页</a></li>
                <li><a href="#">流量充值</a></li>
                <li><a href="#">流量单充</a></li>
            </ul>
        </div>
    
        <div id="usual1" class="usual">  
  	        <div class="formbody">    
                <div class="formtitle"><span>流量单充</span></div>    
                <div class="chong lh33">
                    <b>手机流量充值：以移动、联通、电信三大运营商流量作为合作资源，企业或个人可通过本平台购买流量或作为促销礼品赠送其他手机用户，简单快捷；根据运营商不同，有不同流量、地区，一般即充即到，不长于24小时内到达账户。一旦充值不可撤消，提交前请仔细核对；如果一次充值量大可予优惠 </b>
                </div>
                <ul class="forminfo">
                    <li>
                        <label>手机号码</label>
                        <input v-model="mobile" maxlength="11" @blur="getlldax()" type="text" class="dfinput" />
                        <b style="margin-left: 15px;">{{gsd}}</b>
                    </li>
                    <li>
                        <label>充值流量</label>
                        <div class="left">
                            <template v-for="(item, index) in lldxList">
                                <a :class="lldxcurrent == index ? 'choicell_a' :'choicell' " href="#" @click="changelldx(item.lldx,index)"> {{item.lldx}} </a>&nbsp;&nbsp;&nbsp;&nbsp;
                            </template>
                        </div>
                    </li>
                    <li>
                        <label>流量类型</label>
                        <div class="left">
                            <template v-for="(item, index) in syfwList">
                                <a :class="syfwcurrent == index ? 'choicell_a' :'choicell'" href="#" @click="changesyfw(item.syfw, index)">{{item.syfw}}</a>&nbsp;&nbsp;&nbsp;&nbsp;
                            </template>
                        </div>
                    </li>
                    <li>
                        <label>流量有效期</label>
                        <div class="left">
                            <template v-for="(item, index) in yxqList">
                                <a :class="yxqcurrent == index ? 'choicell_a' :'choicell'" href="#" @click="changellyxq(item.llyxq, index)">{{item.llyxq}}{{item.class}}</a>&nbsp;&nbsp;&nbsp;&nbsp;
                            </template>
                        </div>
                    </li>
                    <li>
                        <label>生效时间</label>
                        <div class="left">
                            <template v-for="(item, index) in sxsjList">
                                <a :class="sxsjcurrent == index ? 'choicell_a' :'choicell'" href="#" @click="changesxsj(item.sxsj, index)">{{item.sxsj}}</a>&nbsp;&nbsp;&nbsp;&nbsp;
                            </template>
                        </div>
                    </li>
                    <li>
                        <label>实付金额</label>
                        <div class="left">
                            <template v-for="(item, index) in shoujiaList">                                
                                <a :class="sfjecurrent == index ? 'choicell_a' :'choicell' " href="#" @click="changeshoujia(item.shoujia, index)">{{item.shoujia}}{{item.class}}</a>&nbsp;&nbsp;&nbsp;&nbsp;
                            </template>
                        </div>
                    </li>
                    <li>
                        <label>&nbsp;</label>
                        <input class="sure" type="button" :disabled="chargeDis" value="提交充值" @click="submitcharge()">&nbsp;
                    </li>
                </ul>
                <div class="jian">&nbsp;</div>
            </div>   	
	    </div> 
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            mobile:'',
            lldxList:[],
            syfwList: [],
            yxqList: [],
            sxsjList: [],
            shoujiaList: [],
            lldx:'',
            syfw: '',
            yxq: '',
            sxsj: '',
            shoujia: '',
            gsd: '',
            zoopIndex: '',
            lldxcurrent: -1, //流量大小选中下标
            syfwcurrent:-1,  //使用范围（流量类型）选中下标
            yxqcurrent:-1,   //流量有效期选中下标
            sxsjcurrent:-1,  //生效时间选中下标
            sfjecurrent:-1,  //实付金额选中下标
            check: {
                czsf: '',
                syfw: '',
                yys: '',
                lldx: '',
                sxsj: '',
                shoujia: '',
            },
            index: -1,
            chlldx:'',
            chargeDis: false,
        }
    },
    mounted(){
        // this.getlldax()
    },
    methods:{
        getlldax(){
            if(this.mobile.length == 11){
                this.cleanlldx();
                this.cleansyfw();
                this.lldxcurrent = -1;
                var that = this;
                let data = {'mobile':this.mobile};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/llrecharge/lldx.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.lldxList = res.data.lldxList;
                        that.gsd = res.data.gsd
                        that.check.czsf = res.data.sf
                        that.check.yys = res.data.yys
                        // that.lldx = that.lldxList[0].lldx;
                        // that.lldx = 0
                        if(that.lldxList.length == 0)
                        {
                            that.gsd =  res.data.gsd + ' 该地区没有流量包可充值'
                            that.cleandata()
                        }
                        else if(that.lldxList.length == 1){
                            that.changelldx(that.lldxList[0].lldx,0);
                        }
                    }
                    else
                    {
                        that.$alert(res.data.msg)
                    }
                })
            }
            else
            {
                this.gsd = '请输入正确的手机号'
                this.cleandata()
            }
        },
        cleandata() {
            this.syfw = ''
            this.yxq = ''
            this.sxsj = ''
            this.shoujia = ''
            this.lldxList = []
            this.syfwList = []
            this.yxqList = []
            this.sxsjList = []
            this.shoujiaList = []
            this.zoopIndex = ''
            this.lldx = ''
            this.check = {}
        },
        changelldx(lldx, index) {  
            this.lldxcurrent = index;
            this.cleansyfw();
            this.lldx = lldx
            let param = {'czsf': this.check.czsf, 'yys': this.check.yys, 'lldx': this.lldx}
            var that = this
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/llrecharge/syfw.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.syfwList = res.data.lldxList;
                    if(null == that.syfwList || that.syfwList.length == 0){

                    }
                    else if(that.syfwList.length == 1){
                        that.changesyfw(that.syfwList[0].syfw,0);
                        that.syfw = that.syfwList[0].syfw
                    }
                    else
                    {
                        that.syfw = ''
                    }
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        changesyfw(syfw, index) {
            this.syfwcurrent = index;            
            this.cleanyxq()
            this.syfw = syfw;
            let param = {'czsf': this.check.czsf, 'yys': this.check.yys, 'lldx': this.lldx, 'syfw': this.syfw}
            var that = this
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/llrecharge/llyxq.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.yxqList = res.data.lldxList;
                    if(null == that.yxqList || that.yxqList.length == 0){

                    }
                    else if(that.yxqList.length == 1){
                        that.changellyxq(that.yxqList[0].llyxq, 0);
                        that.yxq = that.yxqList[0].llyxq
                    }                    
                    else
                    {
                        that.yxq = ''
                    }
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        changellyxq(yxq, index) {
            this.yxqcurrent = index;
            this.cleansxsj()
            this.yxq = yxq;
            let param = {'czsf': this.check.czsf, 'yys': this.check.yys, 'lldx': this.lldx, 'syfw': this.syfw, 'llyxq': this.yxq}
            var that = this
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/llrecharge/sxsj.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.sxsjList = res.data.lldxList;
                    if(null == that.sxsjList || that.sxsjList.length == 0){

                    }
                    else if(that.sxsjList.length == 1){
                        that.changesxsj(that.sxsjList[0].sxsj, 0);
                        that.sxsj = that.sxsjList[0].sxsj;
                    }
                    else
                    {
                        that.sxsj = ''
                    }
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        changesxsj(sxsj, index) {
            //生效时间
            this.sxsjcurrent = index;
            
            
            this.cleanshoujia();
            this.sxsj = sxsj;
            let param = {'czsf': this.check.czsf, 'yys': this.check.yys, 'lldx': this.lldx, 'syfw': this.syfw, 'llyxq': this.yxq, 'sxsj': this.sxsj}
            var that = this
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/llrecharge/shoujia.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.shoujiaList = res.data.lldxList;
                    if(null == that.shoujiaList || that.shoujiaList.length == 0){

                    }
                    else if(that.shoujiaList.length == 1){
                        that.changeshoujia(that.shoujiaList[0].shoujia, 0);
                    }
                    if(that.shoujiaList.length == 1)
                    {
                        that.shoujia = that.shoujiaList[0].shoujia
                    }
                    else
                    {
                        that.shoujia = ''
                    }
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        submitcharge() {
            if(this.mobile.length != 11)
            {
                this.$alert('请输入正确的手机号');
                return false;
            }
            if(this.lldx == '')
            {
                this.$alert("请选择充值流量大小!")
                return false;
            }
            if(this.syfw == '')
            {
                this.$alert("请选择流量使用范围!")
                return false;
            }
            if(this.yxq == '')
            {
                this.$alert("请选择流量有效期!")
                return false;
            }
            if(this.sxsj == '')
            {
                this.$alert("请选择生效时间!")
                return false;
            }
            if(this.shoujia == '')
            {
                this.$alert("请选择实付金额!")
                return false;
            }
            this.chargeDis = true;
            var that = this
            let param = {'lldx': this.lldx, 'mobile': this.mobile, 'syfw': this.syfw, 'llyxq': this.yxq, 'sxsj': this.sxsj, 'shoujia': this.shoujia, 'czsf': this.check.czsf, 'yys': this.check.yys,}
            // this.$alert(JSON.stringify(param))
            // return 
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/llrecharge/llrecharge.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$alert("任务提交成功！", '提示', {
                        confirmButtonText: '确定',                            
                        type: 'warning'
                    }).then( () => {
                        location.reload()
                    })
                }
                else
                {
                    that.$alert(res.data.msg)
                    return false;
                }
            })
        },
        changeshoujia(shoujia, index) {
            //选择价格
            this.sfjecurrent = index;
            this.shoujia = shoujia;
            
        },
        cleanlldx(){
            this.lldx = '';
            this.lldxList = [];
            this.lldxcurrent = -1;
        },
        cleansyfw() {
            this.syfw = '';
            this.syfwList = [];
            this.syfwcurrent = -1;
            this.cleanyxq();
            this.cleansxsj();
            this.cleanshoujia();
        },
        cleanyxq() {
            this.yxq = '';
            this.yxqList = [];
            this.yxqcurrent = -1;
            this.cleansxsj();
            this.cleanshoujia();
        },
        cleansxsj() {
            this.sxsj = ''
            this.sxsjList = [];
            this.cleanshoujia()
        },
        cleanshoujia() {
            this.shoujia = '';
            this.shoujiaList = [];
        }
    }
    
}
</script>



// WEBPACK FOOTER //
// src/components/liuliang/llrecharge.vue